import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import AppPreview from '../components/AppPreview';
import Waitlist from '../components/Waitlist';
import Footer from '../components/Footer';

function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Features />
        <AppPreview />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
}

export default Home;
